/*eslint-env browser*/

function download ({name, fileName = name, url, mimeType}) {
    let downloadLink = window.document.createElement("a")
    downloadLink.download = fileName
    downloadLink.href     = url
    downloadLink.dataset.downloadurl = [mimeType, fileName, url].join(":")

    let {body} = window.document
    body.appendChild(downloadLink)
    downloadLink.click()
    setTimeout(function () {
        body.removeChild(downloadLink)
        window.URL.revokeObjectURL(url)
    }, 0)
}


function downloadAsFile ({name, fileName = name, content}) {
    let mimeType = "text/plain"
    if (fileName.endsWith(".json")) {
        mimeType = "application/json"
    }

    let blob

    if (content instanceof Blob) {
        blob = content
    } else if (content instanceof ArrayBuffer || content instanceof Uint8Array) {
        mimeType = "application/octet-stream"
        blob = new Blob([content], {type: mimeType})
    } else {
        if (typeof content === "object") {
            content = JSON.stringify(content)
        } else {
            content = content.toString()
        }

        blob = new Blob([content], {type: `${mimeType};charset=utf-8`})
    }

    let url = URL.createObjectURL(blob)

    download({url, fileName, mimeType})
}


function downloadCanvasAsPNG (canvas, fileName) {
    const mimeType = "image/png"
    const url = canvas.toDataURL(mimeType)
    download({fileName, mimeType, url})
}


function downloadCanvasAsJPG (canvas, fileName, quality = 0.7) { //eslint-disable-line no-magic-numbers
    if (!extensionFor(fileName)) {
        fileName += ".jpg"
    }
    const mimeType = "image/jpeg"
    const url = canvas.toDataURL(mimeType, quality)
    download({fileName, mimeType, url})
}


function downloadCanvasAsImage (canvas, { //eslint-disable-line complexity
    format,
    name     = "new_image",
    fileName = name,
    quality
}) {
    if (!format) {
        let extension = extensionFor(fileName)
        if (extension === "jpg" || extension === "jpeg") {
            format = "jpg"
        } else {
            format = "png"
        }
    }

    fileName = ensureExtensionMatchesFormat(fileName, format)

    if (format === "png") {
        downloadCanvasAsPNG(canvas, fileName)
    } else if (format === "jpg" || format === "jpeg") {
        downloadCanvasAsJPG(canvas, fileName, quality)
    } else {
        throw new Error(`Format ${format} not supported`)
    }
}



function blobToBase64 (blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload  = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
    })
}



function extensionFor (fileName) {
    return fileName.slice((Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1)
}


const formatExtensions = {png: "png", jpg: "jpg", jpeg: "jpg"}

function ensureExtensionMatchesFormat (fileName, format) {
    const currentExt = extensionFor(fileName).toLowerCase()
    const expectedExt = formatExtensions[format]
    if (!expectedExt) {
        return fileName
    }
    if (currentExt === format || currentExt === expectedExt) {
        return fileName
    }
    if (currentExt) {
        return `${fileName.slice(0, fileName.lastIndexOf("."))}.${expectedExt}`
    }
    return `${fileName}.${expectedExt}`
}


export default {
    downloadAsFile,
    downloadCanvasAsImage,
    downloadCanvasAsPNG,
    downloadCanvasAsJPG,
    blobToBase64
}
